import ScheduleEntry from '../models/ScheduleEntry';

/**
 * Simplified drag and drop interface that works directly with ScheduleEntry objects
 */
export interface DraggedScheduleEntry {
    /** The ScheduleEntry being dragged */
    entry: ScheduleEntry | null;
    /** Click offset for accurate positioning during drag */
    clickOffsetY: number;
    /** Duration in minutes for positioning calculations */
    durationMinutes: number;
    /** Type of drag operation */
    typeDnd: string;
    /** Days where this entry can be dropped */
    allowedDays: string[];
}

/**
 * Default empty dragged entry state
 */
export const createEmptyDraggedEntry = (): DraggedScheduleEntry => ({
    entry: null,
    clickOffsetY: 0,
    durationMinutes: 0,
    typeDnd: '',
    allowedDays: []
});
